import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver errors from Radix UI components
// These errors don't affect functionality but clutter the console
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args && args.length > 0 && typeof args[0] === 'string') {
    // Suppress ResizeObserver loop errors
    if (args[0].includes('ResizeObserver loop')) {
      return;
    }
  }
  resizeObserverErr(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
